import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class Test150326 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 15/03/2026 Candidates(Sattahip)</h3>
      <br />
      <br />

        <div><Link to='/conduct-sanphets'>1. AAT 7761  CPO1.SANPHET SUKPRATHUEANG(SHODAN-HO)---Trying for SHODAN</Link></div>
        <br />
        <div><Link to='/conduct-jarunnops'>2. AAT 7561  MR.JARUNNOP SIRIVORAPAIBOON(SHODAN-HO)---Trying for SHODAN</Link></div>
        <br />
        <div><Link to='/conduct-rattapongp'>3. AAT 4478  LT.RATTAPONG PONGSUWAN(1KYU)---Trying for SHODAN-HO</Link></div>
        <br />
        <div><Link to='/conduct-metapornc'>4. AAT 7833  MS.METAPORN CHIM-IM(1KYU)---Trying for SHODAN-HO</Link></div>
        <br />
        <div><Link to='/conduct-kanokphonc'>5. AAT 7779  MS.KANOKPHON CHAIYAWONG(1KYU)---Trying for SHODAN-HO</Link></div>
        <br />
        <div><Link to='/conduct-ratchadapornn'>6. AAT 7822  MS.RATCHADAPORN NONNUSAT(4KYU)---Trying for 3KYU</Link></div>
        <br />
        <div><Link to='/conduct-thomasm'>7. AAT 7923  MR.THOMAS MOENKEMEIER(5KYU)---Trying for 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-napolp'>8. ATT  7910  MR.NAPOL PITAYAPAT(5KYU)---Trying for 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-asdawutc'>9. ATT  7925  LT.ASDAWUT CHODSAPTHAWEE(6KYU)---Trying for 5KYU</Link></div>
        <br />
        <div><Link to='/conduct-nirunc'>10. AAT 7783  LT.NIRUN CHANTAWARO(7KYU)---Trying for 6KYU</Link></div>
        <br />
        <div><Link to='/conduct-sunyal'>11. AAT 7972  CPO1.SUNYA LAEID(7KYU)---Trying for 6KYU</Link></div>
        <br />
        <div><Link to='/conduct-marceld'>12. AAT 8024  MR.MARCEL DEKE(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-nannaphatp'>13. AAT 8028  ​MS.NANNAPHAT PRIYACHANASAKUL(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-kanyaphatp'>14. AAT 8026  MS.KANYAPHAT PRIYACHANASAKUL(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-nueas'>15. AAT 8006  MS.NUEA SUDRAK(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-panyasuphak'>16. AAT 8029  MS.PANYASUPHA KHEMARUT(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-marks'>17. AAT 8041  MR.MARK SRIAPORN(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-marvins'>18. AAT 8042  MR.MARVIN SRIAPORN(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-mitts'>19. AAT 8043  MR.MITT SRIAPORN(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-zaidena'>20. AAT 8044  MR.ZAIDEN ANDERSSON(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-benjaminb'>21. AAT 8045  MR.BENJAMIN BROWN(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-tylerb'>22. AAT 8046  MR.TYLER BROWN(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-wyonab'>23. AAT 8047  MS. WYONA BROWN(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-kansinees'>24. AAT 8048  MS.KANSINEE SAIMONTREE(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-narns'>25. AAT 8049  MR.NARN SUDRAK(WB)---Trying for 10KYU</Link></div>
        <br />


        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Test150326;
